import {customerSlice} from './customerSlice';

export default customerSlice.reducer;
